import { useQuery } from '@tanstack/react-query';

import { $apiV2 } from '../../global';
import { IFeature } from '../models';

export const getFeatures = async () => {
  const { data } = await $apiV2.get<IFeature>('/pro-function/view?type=akam_pro');

  return { features: data?.data };
};

export const useFeatures = () => {
  const { data, ...args } = useQuery({
    queryKey: ['pro-features'],
    queryFn: getFeatures
  });

  return { ...data, ...args };
};
